export interface StockAddPartLineForm {
  id: string;
  catalogPieceId: string;
  quantity: string;
  etatPiece: string;
  emplacement: string;
}

const createLineId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `part-line-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
};

export const createEmptyAddPartLine = (): StockAddPartLineForm => ({
  id: createLineId(),
  catalogPieceId: '',
  quantity: '1',
  etatPiece: '',
  emplacement: '',
});

export const isAddPartLineComplete = (line: StockAddPartLineForm): boolean => {
  const parsedQuantity = Number.parseInt(line.quantity, 10);

  return (
    line.catalogPieceId !== '' &&
    line.etatPiece !== '' &&
    Number.isFinite(parsedQuantity) &&
    parsedQuantity >= 1
  );
};

export const parseAddPartLineQuantity = (line: StockAddPartLineForm): number =>
  Math.max(1, Math.floor(Number.parseInt(line.quantity, 10) || 1));
